import React, { Component } from 'react';
import formDataSchema from '../../../schema/idle-tat-report';
import moment from 'moment';
import { CSVLink } from "react-csv";
import * as R from 'ramda';
import Pagination from "react-js-pagination";
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
import { Switch, Spin, Tooltip, Modal, Button, notification } from 'antd';
import DateRange from '../../../components/FormComponent/DateRange';

const {homepage} = networkList;
class ReCounselling_Done extends Component {
    // print = () => {
    //     window.print();
    // }


    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            appTime: [],
            headding: null,
            postdata: {},
            filtereData: [],
            reportData: [],
            reportHead: [],
            reportExcelData: [],
            visible: false,
            dateTo: moment().format('YYYY-MM-DD'),
            dateFrom: moment().subtract(7, 'd').format('YYYY-MM-DD'),
            activePage: 1,
            totalItems: 0,
            isLoading: false,
            downloadStatus: 0,
            'thead': [],
            'tbody': []
        };
    }

    componentDidMount() {
        formDataSchema.feilds.map((data, key) => {
            formDataSchema.feilds[key]['value'] = null
            formDataSchema.feilds[key]['text'] = null
        })
        this.setState((state) => ({ filtereData: formDataSchema.feilds }), () => {
            this.fetchData(this.state.filtereData);
            // this.renderHead();
            this.loadPage()
        });
    }

    fetchData(fetchData) {
        var payload = {
            "from_date": this.state.dateFrom,
            "to_date": this.state.dateTo,
            "page": this.state.activePage
        }
        // console.log('payload:', payload);
    }

    // renderHead(){
    //     const { slug } = this.props.match.params;
    //     let headding = null;
    //     if(slug === 'tat-reports'){
    //         headding = 'TAT Reports';
    //     }

    //     this.setState((state) => ({ 'headding': headding }))
    // }
    loadPage = () => {
        try {
            let { slug } = this.props.match.params;
            const { getTokenTatReport, getRecounsellingReport } = networkList;
            let tableHead = [];
            // let data = {
            //     "from": this.state.dateFrom,
            //     "to": this.state.dateTo
            // }
            // console.log('data:', data)
            switch (slug) {
                case 'recounselling-report':
                    tableHead = [
                        {
                            "key": 's_no',
                            'text': 'S.No.'
                        }, {
                            "key": 'patient_name',
                            'text': 'Patient’s Name'
                        }, {
                            "key": 'patient_umr',
                            'text': 'Patient UMR'
                        }, {
                            "key": 'mobile_number',
                            'text': 'Phone Number'
                        }, {
                            "key": 'patient_age',
                            'text': 'Patient_age',
                        }, {
                            "key": 'patient_gender',
                            'text': 'Patient Gender'
                        },
                        {
                            "key": 'recounselling_done',
                            'text': 'No.Of. Recounselling Done'
                        },
                        {
                            "key": 'last_counselling_date',
                            'text': 'Last Counselling Date'
                        },
                        {
                            "key": 'last_counselling_by',
                            'text': 'Last Counselling By'
                        }
                    ]
                    this.setState((state) => ({ showFilter: true, tableTitle: 'Re-Counselling Report', thead: tableHead, loadding: true }), () => {
                        postService(getRecounsellingReport, 'POST', {
                            "data": {
                                "from": this.state.dateFrom,
                                "to": this.state.dateTo,
                                "page_data_count": 0
                            }
                        }).then(res => {
                            // console.log(res);
                            // console.log('data res:', data)
                            if (res.status) {
                                this.setState((state) => ({ tbody: res.data, loadding: false }));
                            } else {
                                if (res === 401) {

                                } else {
                                    Modal.error({
                                        title: 'Failure',
                                        content: "Oops, something went wrong... Please try again.",
                                    });
                                }
                            }
                        });
                    });
                    break;
            }
        } catch (error) {
            console.log(error);
        }
    }
    render() {
        let { filtereData, tableTitle, thead, tbody } = this.state;
        return (
            <div className="card m-5 card-table">
                <div className="card-header bg8">
                    <div className="clearfix">
                        <div className="float-left pt-1">
                            {tableTitle}
                        </div>
                        <div>
                            {filtereData
                                .map((feild, key) => {
                                    if (feild.element === 'daterange') {
                                        return (
                                            <div
                                                className={`${feild.className
                                                    ? feild.className
                                                    : 'col '} ${feild.name}`}
                                                key={key}>
                                                <p className="data-label text-white w-25 mb-1 pt-1 text-right pr-2">{feild.text}: </p>
                                                <DateRange
                                                    Queuedata={filtereData}
                                                    selectdata={feild}
                                                    {...this.props}
                                                    {...this.state}
                                                    onselectChanges={(e) => { console.log('onselectChanges:', e.value[0]); this.setState({ dateFrom: e.value[0], dateTo: e.value[1] }); this.loadPage() }}
                                                />
                                            </div>
                                        )
                                    }
                                })}
                        </div>
                    </div>

                </div>
                <div className="financial-table table-responsive">
                    <table className="table table-hover table-bordered mb-0" id="myTable">
                        <thead>
                            <tr>
                                {thead.map((head, key) => {
                                    return (<td className="text-capitalize" key={key}>{head['text']}</td>)
                                })}
                            </tr>
                        </thead>
                        {
                            tbody != ''
                                ?
                                <tbody>
                                    {tbody.map((item, index) => {
                                        return (<tr key={index}>
                                            <td>{index + 1}</td>
                                            <td className="text-capitalize">{(item.patient_name !== null) ? (item.patient_name !== "null") ? item.patient_name : "--" : "--"}</td>
                                            <td className="text-uppercase">{(item.umr_no !== null) ? (item.umr_no !== "null") ? item.umr_no : "--" : "--"}</td>
                                            <td>{(item.mobile_number !== null) ? (item.mobile_number !== "null") ? item.mobile_number : "--" : "--"}</td>
                                            <td className="text-capitalize">{(item.patient_age !== null) ? (item.patient_age !== "null") ? item.patient_age : "--" : "--"}</td>
                                            <td className="text-capitalize">{(item.patient_gender !== null) ? (item.patient_gender !== "null") ? item.patient_gender : "--" : "--"}</td>
                                            <td>{(item.recounselling_count !== null) ? (item.recounselling_count !== "null") ? item.recounselling_count : "--" : "--"}</td>
                                            <td className="text-capitalize">{(item.date_of_counselling !== null) ? (item.date_of_counselling !== "null") ? item.date_of_counselling : "--" : "--"}</td>
                                            <td className="text-capitalize">{(item.counsellor_name !== null) ? (item.counsellor_name !== "null") ? item.counsellor_name : "--" : "--"}</td>
                                        </tr>)
                                    }
                                    )}
                                </tbody>
                                :
                                <tbody>
                                    <tr>
                                        <td colSpan="12" className="text-center">
                                            <img src={homepage+"/assets/images/icons/no-data.svg"} alt="" />
                                            <p className="no-data mb-0">No Data</p>
                                        </td>
                                    </tr>
                                </tbody>
                        }

                    </table>
                </div>
            </div>

        )
    }
}
export default ReCounselling_Done